import { motion } from 'framer-motion';

const CaseCTA = () => {
  const handleTestClick = () => {
    window.REACT_APP_NAVIGATE('/test');
  };

  const handleConsultClick = () => {
    // 咨询功能预留
    alert('咨询功能开发中，请稍后再试');
  };

  return (
    <section className="bg-gradient-to-br from-[#1A3A5C] to-[#2A4A6C] py-20">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <i className="ri-rocket-line text-6xl text-[#FFB800] mb-6"></i>
          
          <h2 className="text-3xl font-bold text-white mb-4">
            找到适合您的案例了吗？
          </h2>
          
          <p className="text-lg text-white/90 mb-8">
            立即测试您的业务是否适合 1039 市场采购贸易模式
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <motion.button
              onClick={handleTestClick}
              className="px-8 py-4 bg-[#FFB800] text-white rounded-xl font-bold hover:bg-[#E5A600] transition-colors shadow-lg whitespace-nowrap"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <i className="ri-test-tube-line mr-2"></i>
              测试我是否适合 1039
            </motion.button>

            <motion.button
              onClick={handleConsultClick}
              className="px-8 py-4 bg-white/10 text-white rounded-xl font-bold hover:bg-white/20 transition-colors border-2 border-white/30 whitespace-nowrap"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <i className="ri-customer-service-2-line mr-2"></i>
              咨询类似案例
            </motion.button>
          </div>

          <div className="mt-12 pt-8 border-t border-white/20">
            <p className="text-sm text-white/70">
              <i className="ri-shield-check-line mr-2"></i>
              所有案例均基于真实业务场景 · 数据已做合规化处理 · 不构成任何承诺或保证
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CaseCTA;